const getClosestByEventPath = function(e, classname) {

    const path = e.path || e.composedPath() || e.deepPath || false;
    if(typeof(classname) === 'string' && path && path.length) {
        let isContains = false;
        let $domElement = null;
        const values = path.values();

        for(const $element of values) {
            if($element !== document && $element !== window && $element.classList.contains(classname)) {
                $domElement = $element;
                isContains = true;
                break;
            }
        }

        return isContains ? $domElement : false;
    }

    return false;
};

export { getClosestByEventPath };
